import React from "react";

import { Text } from "@chakra-ui/react";

interface SymptomDisplayProps {
  symptom: string;
}

export const SymptomDisplay: React.FC<SymptomDisplayProps> = ({ symptom }) => {
  return <Text>• {symptom}</Text>;
};
